import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CFormSelect,
} from '@coreui/react';
import Select from 'react-select'
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import axios from "axios";
import { formatShortName, formatUTC } from 'src/store';
import dayjs from 'dayjs';
import AddHeaderSlider from 'src/components/headers/AddHeaderSlider';
import AxiosInstance from 'src/components/Axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import MyToastify from 'src/components/myComponents/MyToactify';
import PageInfoList from 'src/components/page-info/PageInfoList';
import ProductCategories from 'src/components/product/ProductCategories';
import MyToastify from 'src/components/myComponents/MyToactify';
import MediaFrom from '../../components/media/MediaFrom';
import AddCategories from 'src/components/category/AddCategories';
import LangugesPanel from './LangugesPanel';
import RelatedPublications from 'src/components/related/RelatedPublications';

import Tab from 'react-bootstrap/Tab';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import { confirmAlert } from 'react-confirm-alert';

import { reactSelectStyles, reactSelectStylesType1 } from '../../styles/reactSelectStyles';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const navNames = {
  info: 'Загальні',
  // models: 'Модель',
  slider: 'Слайдер',
  img: 'Зображення',
  // gallery: 'Галерея',
  // attributes: 'Атрибути',
  category: 'Категоріі',
  data: 'Додаткові дані',
  // publications: 'Публікаціі'
  // scannings: 'Сканування',
};

export async function LoaderProjectsUpdate({ params }) {
  if (Object.keys(params).length != 0) {
    let res = await axios.get(process.env.REACT_APP_SERVER_URL + '/api/projects/' + params.prodId, {
      params: {
        "g[0]": "projects:read",
        "g[1]": "projects:financed",
        "g[2]": "projects:partners",
        "g[3]": "projects:coordinator"
      }
    }).then((response) => {
      return response;
    });
    return res;
  }
  return false;
}
const formReducer = (state, event) => {
  return {
    ...state,
    [event.target.name]: event.target.value
  }
}
const ProjectsForm = () => {
  const { data } = useLoaderData();
  const [name, setName] = useState((data != undefined) ? data.name : '');
  const [shortName, setShortName] = useState((data?.shortName != undefined) ? formatShortName(data.shortName) : '');
  const [shortDescription, setShortDescription] = useState((data != undefined) ? data.shortDescription : '');
  const [status, setStatus] = useState((data != undefined) ? data.status : '');
  const [budget, setBudget] = useState((data != undefined) ? data.budget : '');
  const [media, setMedia] = useState((data != undefined) && data.mainMedia?.id);
  const [mediaUrl, setMediaUrl] = useState(false);

  // Викликає popup з власного компонента
  const popup = MyToastify();
  // const [financed, setFinanced] = useState((data != undefined) ? data.financed : []);
  // const [partners, setPartners] = useState((data != undefined) ? data.partners : []);

  const [dateStart, setDateStart] = useState((data != undefined) ? new Date(data.dateStart).toISOString() : new Date().toISOString());
  const [dateEnd, setDateEnd] = useState((data != undefined) ? new Date(data.dateEnd).toISOString() : new Date().toISOString());
  const [partners, setPartners] = useState((data?.partners != undefined) ? data.partners.map(partner => { return { label: partner.name, value: partner.id } }) : []);
  const [coordinator, setCoordinator] = useState((data?.coordinator != undefined) ? data.coordinator.map(coordinator => { return { label: coordinator.name, value: coordinator.id } }) : []);
  const [financed, setFinanced] = useState((data?.financed != undefined) ? data.financed.map(finance => { return { label: finance.name, value: finance.id } }) : []);
  const [fontSize, setFontSize] = useState('36');
  const [unitOfMeasurement, setUnitOfMeasurment] = useState('px')
  const [currency, setCurrency] = useState((data?.curency != undefined) ? data.curency : "$")

  const [sliders, setSliders] = useState((data != undefined && data.slider != undefined) ? data.slider.match(/(\d+)/)?.[0] : false);
  const [accountOptions, setAccountOptions] = useState([]);
  // const [partnersOptions, setPartnersOptions] = useState([]);
  // const [financeOptions, setFinanceOptions] = useState([]);
  const [language, setLaguage] = useState((data != undefined) ? data.language?.key : 'ua');

  // стан для запису eventKey активного навлінка,показувати чи не показувати svg
  const [activeKey, setActiveKey] = useState('info')
  const [navLinkName, setNavLinkName] = useState('Загальні')

  const [myData, setMyData] = useState(data)

  const editorRef = useRef(null);
  const navigate = useNavigate();
  // Ключ для Editor
  const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;

  //значеня для селекту одиниць виміру
  const unitsOfMeasurement = [
    { value: 'px', label: 'px' },
    { value: 'rem', label: 'rem' },
    { value: 'em', label: 'em' },
  ];
  //значення для селекту вибору валюти
  const unitsOfCurrency = [
    { value: '$', label: 'долар' },
    { value: '€', label: 'євро' },
    { value: '₴', label: 'гривня' },
  ];

  const handleChangeUnitsOfMeasurment = (selectedOption) => {
    // console.log('Selected unit:', selectedOption.value);
    setUnitOfMeasurment(selectedOption.value);
  };

  const handleChangeCurrency = (selectedOption) => {
    // console.log('Selected unit:', selectedOption.value);
    setCurrency(selectedOption.value);
  };
  useEffect(() => {
    if (data) {
      setName(data.name || '');
      setShortName(data.shortName ? formatShortName(data.shortName) : '');
      setShortDescription(data.shortDescription || '');
      setStatus(data.status || '');
      setBudget(data.budget || '');
      setMedia(data.mainMedia?.id || undefined);
      setDateStart(data.dateStart ? new Date(data.dateStart).toISOString() : new Date().toISOString());
      setDateEnd(data.dateEnd ? new Date(data.dateEnd).toISOString() : new Date().toISOString());
      setPartners(
        data.partners
          ? data.partners.map((partner) => ({ label: partner.name, value: partner.id }))
          : []
      );
      setFinanced(
        data.financed
          ? data.financed.map((finance) => ({ label: finance.name, value: finance.id }))
          : []
      );
      setCoordinator(
        data.coordinator
          ? data.coordinator.map((coordinator) => ({ label: coordinator.name, value: coordinator.id }))
          : []
      );
      setCurrency(data.curency || '$');
      setSliders(
        data.slider ? data.slider.
          // split('/').shift() : false
          match(/(\d+)/)?.[0] : false
      );
      // setLaguage(data.language?.key || 'ua');
    }
  }, [data]);

  useEffect(() => {
    // console.log(media);
    if (media) {
      AxiosInstance.get(`/media_objects/${media}`).then((response) => {
        if (response.status == 200) {
          setMediaUrl(response.data.contentUrl)
        }
      });
    }
  }, [media]);

  useEffect(() => {
    AxiosInstance.get('/accounts?pagination=false').then((response) => {
      const data = response.data['hydra:member'];
      const accountOptions = data.map(account => {
        return { label: account.name, value: account.id }
      })
      setAccountOptions(accountOptions);

    }).catch((err) => console.log(err));
  }, [])

  useEffect(() => {
    if (data?.shortName !== undefined) {
      const regex = /font-size:([\d\.]+)([a-zA-Z%]+)/;
      const match = data.shortName.match(regex);
      if (match) {
        setFontSize(match[1]);
        setUnitOfMeasurment(match[2]);
      }
    }
  }, [data?.shortName]);

  const handleSubmit = event => {
    event.preventDefault();
    if (editorRef.current) {

      const article = {
        name: name,
        shortName: `<h1 style='font-size:${fontSize}${unitOfMeasurement}'>${shortName}</h1>`,
        dateStart: dateStart,
        dateEnd: dateEnd,
        status: status,
        shortDescription: shortDescription,
        partners: partners.map(partner => `/api/accounts/${partner.value}`),
        financed: financed.map(finance => `/api/accounts/${finance.value}`),
        coordinator: coordinator.map(coordinator => `/api/accounts/${coordinator.value}`),
        show: data?.show !== undefined ? data?.show : false,
        mainMedia: (media && media !== undefined) ? `/api/media_objects/${media}` : null,
        budget: parseInt(budget) || 0,
        content: editorRef.current.getContent(),
        curency: currency,
        ...(data?.slider ? { slider: data.slider } : {}),
      };
      // console.log(article);
      if (data != undefined) {
        article.language = data.language ? `/api/languages/${data.language.id}` : `/api/languages/1`;
        const response = axios.put(process.env.REACT_APP_SERVER_URL + '/api/projects/' + data.id, article, header).then(() => { navigate('/projects'); });
      } else {
        article.language = `/api/languages/1`;
        const response = axios.post(process.env.REACT_APP_SERVER_URL + '/api/projects', article, header).then(() => { navigate('/projects'); });
      }
    }
  }

  function makeHidden() {
    if (myData.show) {
      confirmAlert({
        title: `Ви впевнені що хочете приховати проект ?`,
        message: '',
        buttons: [
          {
            label: 'Так',
            onClick: () => {
              axios.put(process.env.REACT_APP_SERVER_URL + '/api/projects/' + data.id, { show: false }, header)
                .then(() => {
                  setMyData(prev => ({ ...prev, show: false }));
                });
            }
          },
          {
            label: 'Ні',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else return
  }


  function makeVisible() {
    if (!myData.show) {
      confirmAlert({
        title: `Ви впевнені що хочете зробити проект видимим ?`,
        message: '',
        buttons: [
          {
            label: 'Так',
            onClick: () => {
              axios.put(process.env.REACT_APP_SERVER_URL + '/api/projects/' + data.id, { show: true }, header)
                .then(() => {
                  setMyData(prev => ({ ...prev, show: true }));
                });
            }
          },
          {
            label: 'Ні',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else return
  }

  return (
    <div className='component_wrapper'>

      <ToastContainer />
      {/* <div className='col d-flex justify-content-end'>
        {data !== undefined &&
          <LangugesPanel data={data}
            // setMyData={setMyData}
            setLaguage={setLaguage}
            language={language} />}
      </div> */}


      <Tab.Container id="left-tabs-example" defaultActiveKey="info" onSelect={(key) => {
        setActiveKey(key);
        setNavLinkName(navNames[key]);
      }}>
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>

                <Nav.Link eventKey="info" className='styled_nav_link'>
                  {activeKey === 'info' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="4" cy="4" r="4" fill="#227965" />
                  </svg>}
                  Загальні</Nav.Link>
              </Nav.Item>
              {data !== undefined && <>
                <Nav.Item>
                  <Nav.Link eventKey="slider" className='styled_nav_link'>
                    {activeKey === 'slider' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Слайдер</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="img" className='styled_nav_link'>
                    {activeKey === 'img' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Зображення</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="gallery" className='styled_nav_link'>
                    {activeKey === "gallery" && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Галерея</Nav.Link>
                </Nav.Item> */}
                {/* <Nav.Item>
                  <Nav.Link eventKey="attributes" className='styled_nav_link'>
                    {activeKey === 'attributes' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Атрибути</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link eventKey="category" className='styled_nav_link'>
                    {activeKey === 'category' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Категоріі</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="data" className='styled_nav_link'>
                    {activeKey === 'data' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Додаткові дані</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="publications" className='styled_nav_link'>
                    {activeKey === 'publications' && <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="4" cy="4" r="4" fill="#227965" />
                    </svg>}
                    Публікаціі</Nav.Link>
                </Nav.Item> */}
              </>}
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <div style={{ display: 'flex' }}>
                <div className='tab-content-title'>
                  <h2 >{navLinkName}</h2>
                </div>
                <div className='col d-flex justify-content-end'>
                  {data !== undefined &&
                    <LangugesPanel data={data}
                      // setMyData={setMyData}
                      setLaguage={setLaguage}
                      language={language} />}
                </div>
              </div>
              <hr />

              <Tab.Pane eventKey="info">
                {/* Блок зображення */}
                {/* {(mediaUrl && mediaUrl != undefined) ? <img style={{ objectFit: 'cover' }} className="mb-3" width={300} height={300} src={process.env.REACT_APP_SERVER_URL + mediaUrl} /> : ''}
                <div className="mb-3">
                  <MediaFrom type="category" setNewMediaId={setMedia} toastifySuccess={popup.toastifySuccess} />
                </div> */}
                {/* Блок зображення (верх) */}


                {/* Блок загальні */}
                <CForm onSubmit={handleSubmit}>
                  {/* Слайдер-винести з форми */}
                  {/* {data !== undefined && <AddHeaderSlider id={(sliders !== false) ? sliders : undefined} newSlider={setSliders} parentUrl={`projects/${data.id}`} />} */}
                  {/* Слайдер(верх) */}
                  <Row>
                    {(mediaUrl && mediaUrl != undefined) ? <Col>
                      <img style={{ objectFit: 'cover' }} className="mb-3" width={300} height={300} src={process.env.REACT_APP_SERVER_URL + mediaUrl} />
                    </Col> : ''}
                    <Col
                    // className="info-col"
                    >
                      <div className="mb-3 info-col">
                        <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
                        <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
                      </div>


                      {data !== undefined && <div className="mb-3">
                        <div className='info-visibility-container'>
                          <h3 className='info-visibility-title'>
                            Project visibility
                          </h3>
                          <div className='info-visibility-buttons-container'>
                            <div className={`visible-info ${myData?.show ? 'info-active-button' : ''}`} onClick={makeVisible}>
                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_2001_8833)">
                                  <path d="M1.58301 9.99999C1.58301 9.99999 4.91634 3.33333 10.7497 3.33333C16.583 3.33333 19.9163 9.99999 19.9163 9.99999C19.9163 9.99999 16.583 16.6667 10.7497 16.6667C4.91634 16.6667 1.58301 9.99999 1.58301 9.99999Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M10.7497 12.5C12.1304 12.5 13.2497 11.3807 13.2497 9.99999C13.2497 8.61928 12.1304 7.49999 10.7497 7.49999C9.36896 7.49999 8.24967 8.61928 8.24967 9.99999C8.24967 11.3807 9.36896 12.5 10.7497 12.5Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2001_8833">
                                    <rect width="20" height="20" fill="white" transform="translate(0.75)" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <span>Visible</span>
                            </div>

                            <div className={`hidden-info ${!myData?.show ? 'info-active-button' : ''}`} onClick={makeHidden}>

                              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_2001_8851)">
                                  <path d="M8.83366 3.53333C9.40727 3.39906 9.99454 3.33194 10.5837 3.33333C16.417 3.33333 19.7503 9.99999 19.7503 9.99999C19.2445 10.9463 18.6412 11.8373 17.9503 12.6583M12.3503 11.7667C12.1215 12.0123 11.8454 12.2093 11.5388 12.3459C11.2321 12.4826 10.9011 12.556 10.5654 12.562C10.2297 12.5679 9.89629 12.5061 9.585 12.3804C9.27371 12.2547 8.99093 12.0675 8.75353 11.8301C8.51613 11.5927 8.32899 11.3099 8.20325 10.9987C8.07751 10.6874 8.01576 10.3539 8.02169 10.0183C8.02761 9.68258 8.10108 9.35153 8.23772 9.04487C8.37436 8.7382 8.57137 8.4622 8.81699 8.23333M1.41699 0.833328L19.7503 19.1667M15.5337 14.95C14.1091 16.0358 12.3746 16.6374 10.5837 16.6667C4.75033 16.6667 1.41699 9.99999 1.41699 9.99999C2.45357 8.06824 3.89127 6.3805 5.63366 5.04999L15.5337 14.95Z" stroke="#181D27" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_2001_8851">
                                    <rect width="20" height="20" fill="white" transform="translate(0.583984)" />
                                  </clipPath>
                                </defs>
                              </svg>

                              <span>Hidden</span>
                            </div>
                          </div>
                        </div>
                      </div>}


                    </Col>

                  </Row>

                  {/* //Додавання інпута і селекта */}
                  <div className='row'>
                    <div className='col info-col'>
                      <div className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Коротка назва</CFormLabel>
                        <CFormInput type="text" id="exampleFormControlInput1" value={shortName} onChange={(e) => setShortName(e.target.value)} autoComplete="off" />
                      </div>
                    </div>
                    <div className='col info-col'>
                      <div className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Розмір шрифта</CFormLabel>
                        <CFormInput type="text" id="exampleFormControlInput1" value={fontSize} onChange={(e) => setFontSize(e.target.value)} autoComplete="off" />
                      </div>
                    </div>
                    <div
                      // className='col info-col'
                      className='col'
                    >
                      <div className="mb-3 react-select-wrapper"
                      >
                        <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput1">Одиниці виміру</CFormLabel>
                        <Select

                          // options={props.defaultStorageElement}
                          options={unitsOfMeasurement}
                          // value={props.storageElement}
                          value={unitsOfMeasurement.find((unit) => unit.value === unitOfMeasurement)}
                          // onChange={(value) => { props.handleChange(value) }}
                          onChange={(value) => { handleChangeUnitsOfMeasurment(value) }}
                          // styles={{
                          //   control: (base, state) => ({
                          //     ...base,
                          //     minHeight: 48,
                          //     height: 48,
                          //     borderColor: state.isFocused ? '#2684FF' : '#CED4DA',
                          //     boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                          //     '&:hover': {
                          //       borderColor: '#2684FF',
                          //     },
                          //   }),
                          //   valueContainer: (base) => ({
                          //     ...base,
                          //     height: 48,
                          //     padding: '0 12px',
                          //     display: 'flex',
                          //     alignItems: 'center',
                          //   }),
                          //   input: (base) => ({
                          //     ...base,
                          //     margin: 0,
                          //     padding: 0,
                          //   }),
                          //   indicatorsContainer: (base) => ({
                          //     ...base,
                          //     height: 48,
                          //   }),
                          //   placeholder: (base) => ({
                          //     ...base,
                          //     margin: 0,
                          //   }),
                          //   singleValue: (base) => ({
                          //     ...base,
                          //     margin: 0,
                          //   }),
                          // }}
                          styles={reactSelectStyles}


                        />
                      </div>
                    </div>
                    {/* //Додавання інпута і селекта */}
                  </div>


                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Короткий опис (Макс.значення 255 символів)</CFormLabel>
                    <CFormInput type="text" id="exampleFormControlInput1" value={shortDescription} onChange={(e) => setShortDescription(e.target.value)} autoComplete="off" />
                  </div>
                  <div className="mb-3 react-select-wrapper">
                    <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput2">Партнери</CFormLabel>
                    <Select
                      value={partners}
                      isMulti
                      name="colors"
                      options={accountOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(value) => {
                        setPartners(value);
                      }}
                      styles={reactSelectStylesType1}
                    />
                  </div>
                  <div className="mb-3 react-select-wrapper">
                    <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput2">Фінансування</CFormLabel>
                    <Select
                      value={financed}
                      isMulti
                      name="colors"
                      options={accountOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(value) => {
                        setFinanced(value);
                      }}
                      styles={reactSelectStylesType1}
                    />
                  </div>
                  <div className="mb-3 react-select-wrapper">
                    <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput2">Координатор</CFormLabel>
                    <Select
                      value={coordinator}
                      isMulti
                      name="colors"
                      options={accountOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={(value) => {
                        setCoordinator(value);
                      }}
                      styles={reactSelectStylesType1}
                    />
                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Статус</CFormLabel>
                    <CFormSelect
                      aria-label="Default select example"
                      onChange={(e) => setStatus(e.target.value)}
                      defaultValue={status}
                      required
                      options={[
                        { label: 'Статус проекту', value: '' },
                        { label: 'Completed', value: 'Completed' },
                        { label: 'Planned', value: 'Planned' },
                        { label: 'Pending', value: 'Pending' }
                      ]}
                    />
                  </div>

                  <div className='row'>
                    <div className='col info-col'>
                      <div className="mb-3">
                        <CFormLabel htmlFor="exampleFormControlInput1">Бюджет</CFormLabel>
                        <CFormInput type="number" id="exampleFormControlInput1" value={budget} onChange={(e) => setBudget(e.target.value)} autoComplete="off" />
                      </div>
                    </div>
                    <div className='col'>
                      <div className="mb-3 react-select-wrapper"
                      >
                        <CFormLabel className='label-base-view' htmlFor="exampleFormControlInput1">Вибір валюти</CFormLabel>
                        <Select
                          options={unitsOfCurrency}
                          value={unitsOfCurrency.find((unit) => unit.value === currency)}
                          onChange={(value) => { handleChangeCurrency(value) }}
                          styles={reactSelectStyles}
                        />
                      </div>
                    </div>

                  </div>

                  {/* <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Фінансування</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={financed} onChange={(e) => setFinanced(e.target.value.split(','))} autoComplete="off" />
        </div>
        <div className="mb-3">
          <CFormLabel htmlFor="exampleFormControlInput1">Партненри</CFormLabel>
          <CFormInput type="text" id="exampleFormControlInput1" value={partners} onChange={(e) => setPartners(e.target.value.split(','))} autoComplete="off" />
        </div> */}

                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Дата створення </CFormLabel>
                    <CFormInput type="date" id="exampleFormControlInput1" value={dayjs(dateStart).format('YYYY-MM-DD')} onChange={(e) => setDateStart(e.target.value)} />
                  </div>
                  <div className="mb-3 info-col">
                    <CFormLabel htmlFor="exampleFormControlInput1">Дата завершення </CFormLabel>
                    <CFormInput type="date" id="exampleFormControlInput1" value={dayjs(dateEnd).format('YYYY-MM-DD')} onChange={(e) => setDateEnd(e.target.value)} />
                  </div>

                  {/* Пов'язані публікаціі */}
                  <RelatedPublications
                    editorRef={editorRef}
                    popup={popup}
                  />
                  {/* Пов'язані публікаціі (верх)*/}

                  <div className="mb-3">
                    <Editor
                      apiKey={apiKey}
                      onInit={(evt, editor) => editorRef.current = editor}
                      initialValue={(data != undefined) ? data.content : ''}
                      init={{
                        height: 700,
                        menubar: 'edit view insert format',
                        plugins: [
                          'advlist', 'autolink',
                          'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                          'insertdatetime', 'media', 'table', 'help', 'code'
                        ],
                        toolbar: 'undo redo | fontfamily fontsize | fontselect | bold italic backcolor | ' +
                          'alignleft aligncenter alignright alignjustify | ' +
                          'bullist numlist checklist outdent indent | removeformat | link media a11ycheck code table help',
                        // formats: {
                        //   bold: { inline: 'b', remove: 'all' },
                        //   italic: { inline: 'i', remove: 'all' }
                        // },
                        // valid_elements: 'b,strong,i,em',
                        content_style: `
                          body { font-family:FixelDisplayRegular; font-size:14px }
                          b { font-weight: 700 !important; } /* щоб мак точно бачив жирність */
                        `,
                        font_family_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Fixel Display Regular=fixelDisplayRegular; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                        content_css: '/custom.css'
                      }}
                    />
                  </div>
                  <CButton className='item_add_button' type="submit" color="success">
                    {/* Зберегти */}
                    Save
                  </CButton>
                </CForm>
                {/* Блок загальні(верх) */}
              </Tab.Pane>

              <Tab.Pane eventKey="slider">
                {/* Слайдер-винести з форми */}
                {data !== undefined && <AddHeaderSlider id={(sliders !== false) ? sliders : undefined} newSlider={setSliders} parentUrl={`projects/${data.id}`} />}
                {/* Слайдер(верх) */}
              </Tab.Pane>

              <Tab.Pane eventKey="img">
                {/* Блок зображення */}
                {(mediaUrl && mediaUrl != undefined) ? <img style={{ objectFit: 'cover' }} className="mb-3" width={300} height={300} src={process.env.REACT_APP_SERVER_URL + mediaUrl} /> : ''}
                <div className="mb-3">
                  <MediaFrom type="category" setNewMediaId={setMedia} toastifySuccess={popup.toastifySuccess} />
                </div>
                {/* Блок зображення (верх) */}

              </Tab.Pane>


              {(data != undefined) && <>
                <Tab.Pane eventKey="category">
                  {/* Категоріі */}
                  <AddCategories type="projects" data_id={data.id} toastifySuccess={popup.toastifySuccess} />
                  {/* Категоріі (верх) */}
                </Tab.Pane>

                <Tab.Pane eventKey='data'>
                  {/* Дані сторінки */}
                  <div className="mb-3">
                    <PageInfoList id={data.id} type="project" />
                  </div>

                  {/* Дані сторінки(верх) */}
                </Tab.Pane>

                {/* <Tab.Pane eventKey='publications'>
               
                  <RelatedPublications
                    editorRef={editorRef}
                    popup={popup}
                  />
                  
                </Tab.Pane> */}

              </>
              }


            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default ProjectsForm;
